var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
import * as React from "react";
import { Button, Divider, Grid, Header, Modal } from "semantic-ui-react";
import { DetectOnly, ExtrasOnly, Other, ProbeDetect, ProbeOnly } from "../../KitDeserializer";
import { calculateNumOfSlidesForProbe, calculateNumOfTubesForProbe, displayScaleLabelForCart } from "../ihc2/ProbeForm";
import { rnaCishAccessionsPopup } from "../rna-cish/ProbeSetForm";
import { formatMonetaryDecimal } from "./EditKitForm";
import { calculateNumOfSlidesForAmp, calculateNumOfTubesForAmp } from "./HcrAmplifierForm";
import { BundleOfKits, Ihc2Kit, Ihc2PricedKit, PricedBundleOfKits, RnaCishAmplifierComponent, RnaCishCatalogVariantRefProbeSet, RnaCishLeicaBuffersComponent, RnaCishLibraryOrganismCustomTargetProbeSet, RnaCishManualBuffersComponent, RnaCishOncoreProXBuffersComponent, RnaCishOtherOrganismCustomTargetProbeSet, RnaCishRocheBuffersComponent, RnaFishBuffersComponent, RnaFishKit, RnaFishPricedKit, SimpleCatalogVariantProbeSet, SimpleProbeSetComponent } from "./KitModel";
import { calculateNumOfSlidesForProbeSet, calculateNumOfTubesForProbeSet, noAccessionsMsg } from "./ProbeSetForm";
var KitDisplay = /** @class */ (function (_super) {
    __extends(KitDisplay, _super);
    function KitDisplay(props) {
        var _this = _super.call(this, props) || this;
        _this.probeSet = function (legacy, admin, psc, sampleType, priceCents) {
            var rna = psc.probeSet instanceof SimpleCatalogVariantProbeSet ? psc.probeSet.customerSequence : psc.probeSet.target.targetMrnaSeq;
            var accessionsForBlast = psc.probeSet instanceof SimpleCatalogVariantProbeSet
                ? [psc.probeSet.customerAccessionNum]
                : [psc.probeSet.target.accession];
            var copyClickLink = function () { return _this.onCopyClick(rna); };
            var probeSetSizeDisplay;
            if (admin) {
                probeSetSizeDisplay = psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                    psc.probeSet.variant.probeSetSize + " | " + numOfBindingSitesDisplay(psc.probeSet.customerProbeSetSize) :
                    psc.probeSet.probeSetSize + " | " + numOfBindingSitesDisplay(psc.probeSet.probeSetSize);
            }
            else {
                probeSetSizeDisplay = psc.probeSet instanceof SimpleCatalogVariantProbeSet ?
                    numOfBindingSitesDisplay(psc.probeSet.customerProbeSetSize) :
                    numOfBindingSitesDisplay(psc.probeSet.probeSetSize);
            }
            return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Probe (v3.0)" : "HCR™ HiFi Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organism"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? psc.probeSet.customerOrganismName : psc.probeSet.organism.name)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Target"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? React.createElement("div", { className: "gene-symbol" }, psc.probeSet.customerTargetName)
                        : React.createElement("div", null,
                            "Custom: ",
                            React.createElement("span", { className: "gene-symbol" }, psc.probeSet.target.name)))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Accession"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof SimpleCatalogVariantProbeSet
                        ? accessionSearchLink(psc.probeSet.customerAccessionNum) :
                        accessionSearchLink(psc.probeSet.target.accession))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        "RNA target sequence (",
                        rna.length,
                        " nt)"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        abbreviateRnaWithModal(rna, false),
                        "\u00A0",
                        _this.state.copyButtonText === 'Copied!' ? React.createElement("strong", null, "Copied!") :
                            React.createElement("a", { style: { cursor: 'pointer' }, onClick: copyClickLink }, _this.state.copyButtonText),
                        " ",
                        _this.props.displayBlastLink
                            && accessionsForBlast.length > 0
                            && rna.length > 0
                            && React.createElement("a", { href: blastUrl(accessionsForBlast, rna) }, "Blast"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "# of binding sites"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probeSetSizeDisplay)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfTubesForProbeSet(psc.scale.valuePmol), calculateNumOfSlidesForProbeSet(psc.scale.valuePmol), legacy ? psc.scale.valueWithUnit : psc.scale.probeConcentratedWithUnit, sampleType))),
                priceCents && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.amplifier = function (legacy, amplifier, sampleType, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Amplifier (v3.0)" : "HCR™ Gold Amplifier"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Label"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.label.name)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfTubesForAmp(amplifier.scale.valuePmol), calculateNumOfSlidesForAmp(amplifier.scale.valuePmol), legacy ? amplifier.scale.valueWithUnit : amplifier.scale.ampConcentratedWithUnit, sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.buffers = function (legacy, manualPro, buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, legacy ? "HCR™ Buffers (v3.0)" : "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Probe Hybridization Buffer" : "HiFi Probe Hybridization Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.hybridization.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Probe Wash Buffer" : "HiFi Probe Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, legacy ? buffers.wash.valueWithUnit : buffers.goldWash.valueWithUnit)),
                !manualPro && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Amplifier Buffer" : "Gold Amplifier Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.amp.valueWithUnit)),
                manualPro && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Pro Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.proAmpWash.valueWithUnit)),
                !legacy && !manualPro && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.goldAmpWash.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.ihc2Probe = function (probe, sampleType, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, "HCR™ Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "2\u00BA Antibody Probe"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probe.probe.name)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "For use with amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, probe.amplifier.amplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfTubesForProbe(probe.scale.ugram), calculateNumOfSlidesForProbe(probe.scale.ugram), probe.scale.valueWithUnit(), sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.ihc2Buffers = function (legacy, buffers, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { size: 'small' }, "HCR™ Buffers"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Antibody Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.antibodyBuffer.valueWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, legacy ? "Amplifier Buffer" : "Gold Amplifier Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.amplificationBuffer.valueWithUnit)),
                !legacy && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Gold Amplifier Wash Buffer"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffers.goldAmpWashBuffer.valueWithUnit)),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.consumerRnaCishKit = function (protocolType, config, psc, amplifier, chromogenComponent, buf, misc) {
            var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k;
            var platformSelection = React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Platform"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        React.createElement(React.Fragment, null, protocolType.alias))));
            var probeLabel = React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'medium' }, "Probe"))));
            var detectLabel = React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'medium' }, "Detect"))));
            var extraLabel = React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'medium' }, "Extras"))));
            var organismAndTarget = (psc != null) ?
                React.createElement(React.Fragment, null,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Organism"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet ?
                            psc.probeSet.customerOrganismName :
                            (psc.probeSet instanceof RnaCishLibraryOrganismCustomTargetProbeSet ?
                                psc.probeSet.organism.displayName() :
                                "Other: " + psc.probeSet.organism.name))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Target"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet
                            ? React.createElement("div", { className: 'gene-symbol' }, psc.probeSet.customerTargetName)
                            : React.createElement("div", null,
                                "Custom: ",
                                React.createElement("span", { className: "gene-symbol" }, psc.probeSet.target.name)))),
                    ((psc.probeSet instanceof RnaCishLibraryOrganismCustomTargetProbeSet
                        || psc.probeSet instanceof RnaCishOtherOrganismCustomTargetProbeSet)
                        && psc.probeSet.target.targetMrnaSeq.length > 0) &&
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                                "RNA target sequence (",
                                psc.probeSet.target.targetMrnaSeq.length,
                                " nt)"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, abbreviateRnaWithModal(psc.probeSet.target.targetMrnaSeq, true)))) : React.createElement(React.Fragment, null);
            var enzyme = (amplifier != null) ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Enzyme"),
                    (((_a = amplifier.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.id) !== "NONE" && ((_b = amplifier.antiHapten2Hrp) === null || _b === void 0 ? void 0 : _b.id) !== "NONE") &&
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "HRP & AP"),
                    (((_c = amplifier.antiHapten2Ap) === null || _c === void 0 ? void 0 : _c.id) !== "NONE" && ((_d = amplifier.antiHapten2Hrp) === null || _d === void 0 ? void 0 : _d.id) === "NONE") &&
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "AP"),
                    (((_e = amplifier.antiHapten2Ap) === null || _e === void 0 ? void 0 : _e.id) === "NONE" && ((_f = amplifier.antiHapten2Hrp) === null || _f === void 0 ? void 0 : _f.id) !== "NONE") &&
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "HRP"))) : React.createElement(React.Fragment, null);
            var chromogen = (chromogenComponent != null) ? React.createElement(React.Fragment, null,
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Chromogen"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_g = chromogenComponent.chromogen) === null || _g === void 0 ? void 0 :
                        _g.label,
                        " (", (_h = chromogenComponent.chromogen) === null || _h === void 0 ? void 0 :
                        _h.enzymeCompatibility,
                        " compatible)"))) : React.createElement(React.Fragment, null);
            if (config === ProbeDetect) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, ProbeDetect)),
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc ? psc.scale.slidesWithUnit : "")),
                    probeLabel,
                    organismAndTarget,
                    detectLabel,
                    enzyme,
                    chromogenComponent !== undefined && extraLabel,
                    chromogenComponent !== undefined && chromogen);
            }
            if (config === ProbeOnly) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, ProbeOnly)),
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc ? psc.scale.slidesWithUnit : "")),
                    probeLabel,
                    organismAndTarget);
            }
            if (config === DetectOnly) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, DetectOnly)),
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier ? amplifier.amplifierScale.slidesWithUnit : "")),
                    detectLabel,
                    enzyme,
                    chromogenComponent !== undefined && extraLabel,
                    chromogenComponent !== undefined && chromogen);
            }
            if (config === ExtrasOnly) {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, ExtrasOnly)),
                    platformSelection,
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Scale"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogenComponent ? chromogenComponent.chromogenScale.slidesWithUnit : "")),
                    extraLabel,
                    chromogen);
            }
            else {
                return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Configuration"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, Other)),
                    platformSelection,
                    psc && React.createElement(React.Fragment, null,
                        probeLabel,
                        organismAndTarget,
                        psc.scale.slides > 0 && React.createElement(React.Fragment, null,
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, psc.scale.labelA),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.scale.slidesWithUnit)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, psc.scale.labelB),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.scale.slidesWithUnit)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, psc.probeHybridizationAScale.labelA),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeHybridizationAScale.slidesWithUnit)),
                            React.createElement(Grid.Row, null,
                                React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, psc.probeHybridizationBScale.labelB),
                                React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeHybridizationBScale.slidesWithUnit)))),
                    ((buf instanceof RnaCishRocheBuffersComponent && (buf.dewaxScale.slides > 0 || buf.antigenRetrievalScale.slides > 0))
                        || (buf instanceof RnaCishLeicaBuffersComponent && (buf.bluingAgentScale.slides > 0 || buf.hrpQuencherScale.slides > 0))
                        || (buf instanceof RnaCishOncoreProXBuffersComponent && (buf.bluingAgentScale.slides > 0 || buf.hrpQuencherScale.slides > 0))
                        || (buf != null && (buf.blockingSolutionScale.slides > 0 ||
                            buf.amplificationBufferScale.slides > 0 ||
                            buf.endogenousEnzymeScale.slides > 0 ||
                            buf.preHybridizationScale.slides > 0)) || amplifier != null) && detectLabel,
                    (amplifier != null
                        && (amplifier.antiHapten2Ap.id !== "NONE" || amplifier.antiHapten2Hrp.id !== "NONE")) && enzyme,
                    ((buf === null || buf === void 0 ? void 0 : buf.endogenousEnzymeScale) && buf.endogenousEnzymeScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.endogenousEnzymeScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.endogenousEnzymeScale.slidesWithUnit)),
                    (buf instanceof RnaCishRocheBuffersComponent && buf.dewaxScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.dewaxScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.dewaxScale.slidesWithUnit)),
                    (buf instanceof RnaCishRocheBuffersComponent && buf.antigenRetrievalScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.antigenRetrievalScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.antigenRetrievalScale.slidesWithUnit)),
                    (buf && buf.preHybridizationScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.preHybridizationScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.preHybridizationScale.slidesWithUnit)),
                    (buf && buf.amplificationBufferScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.amplificationBufferScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.amplificationBufferScale.slidesWithUnit)),
                    (amplifier && amplifier.amplifierScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.amplifierScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.amplifierScale.slidesWithUnit)),
                    (buf && buf.blockingSolutionScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.blockingSolutionScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.blockingSolutionScale.slidesWithUnit)),
                    (amplifier && amplifier.antiHapten1Scale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten1Scale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten1Scale.slidesWithUnit)),
                    (amplifier && amplifier.tyramideHaptenScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.tyramideHaptenScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.tyramideHaptenScale.slidesWithUnit)),
                    (amplifier && amplifier.antiHapten2HrpScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten2HrpScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten2HrpScale.slidesWithUnit)),
                    (amplifier && amplifier.antiHapten2ApScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten2ApScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten2ApScale.slidesWithUnit)),
                    ((buf instanceof RnaCishLeicaBuffersComponent || buf instanceof RnaCishOncoreProXBuffersComponent) && buf.hrpQuencherScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.hrpQuencherScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.hrpQuencherScale.slidesWithUnit)),
                    ((buf instanceof RnaCishLeicaBuffersComponent || buf instanceof RnaCishOncoreProXBuffersComponent) && buf.bluingAgentScale.slides > 0) && React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buf.bluingAgentScale.label),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buf.bluingAgentScale.slidesWithUnit)),
                    chromogenComponent && React.createElement(React.Fragment, null,
                        extraLabel,
                        (chromogenComponent && chromogenComponent.chromogenScale.slides > 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, (_j = chromogenComponent.chromogen) === null || _j === void 0 ? void 0 : _j.label),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogenComponent.chromogenScale.slidesWithUnit)),
                        (chromogenComponent && chromogenComponent.chromogenBufferScale.slides > 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, (_k = chromogenComponent.chromogenBuffer) === null || _k === void 0 ? void 0 : _k.label),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogenComponent.chromogenBufferScale.slidesWithUnit)),
                        (chromogenComponent && chromogenComponent.hematoxylinScale.slides > 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Hematoxylin"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogenComponent.hematoxylinScale.slidesWithUnit))),
                    misc && React.createElement(React.Fragment, null,
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, null,
                                React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Other"))),
                        React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Item"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, misc.description)),
                        (misc.scaleInSlides > 0 && misc.scaleInMl.valueMl > 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                misc.scaleInSlides,
                                " slides, ",
                                misc.scaleInMl.valueWithUnit)),
                        (misc.scaleInSlides > 0 && misc.scaleInMl.valueMl <= 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                                misc.scaleInSlides,
                                " slides")),
                        (misc.scaleInMl.valueMl > 0 && misc.scaleInSlides <= 0) && React.createElement(Grid.Row, null,
                            React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                            React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, misc.scaleInMl.valueWithUnit))));
            }
        };
        _this.rnaCishProbeSet = function (admin, psc, price) {
            var rna = psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet ?
                psc.probeSet.variant.targetMrnaSeq : psc.probeSet.target.targetMrnaSeq;
            var accessionForBlast;
            if (psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet) {
                var simpleAccession_1 = psc.probeSet.variant.accession;
                if (simpleAccession_1 != null) {
                    var accession = psc.probeSet.probeSetFamily.accessions.find(function (a) { return a.id === simpleAccession_1.id; });
                    accessionForBlast = accession.transcriptAccession;
                    if (accession.transcriptName != null) {
                        accessionForBlast = accessionForBlast + (" (" + accession.transcriptName + ")");
                    }
                }
                else {
                    accessionForBlast = "";
                }
            }
            else {
                accessionForBlast = psc.probeSet.target.accession;
            }
            return React.createElement(Grid, { columns: 4, className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "HCR\u2122 Pro RNA-ISH Probe"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Organism"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof RnaCishOtherOrganismCustomTargetProbeSet
                        ? "Other: " + psc.probeSet.organism.name
                        : psc.probeSet.organism.name + " " + (psc.probeSet.organism.scientificName.length > 0 ? '(' + psc.probeSet.organism.scientificName + ')' : ''))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Target"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet
                        ? React.createElement("div", { className: "gene-symbol" }, psc.probeSet.probeSetFamily.geneSymbol +
                            ("" + (psc.probeSet.probeSetFamily.description.length > 0 ? ' (' + psc.probeSet.probeSetFamily.description + ')' : '')))
                        : React.createElement("div", null,
                            "Custom: ",
                            React.createElement("span", { className: "gene-symbol" }, psc.probeSet.target.name)))),
                admin && accessionForBlast !== "" && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Accession #"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, accessionSearchLink(accessionForBlast))),
                admin && rna.length > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        "RNA target sequence (",
                        rna.length,
                        " nt)"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        abbreviateRnaWithModal(rna, true),
                        " ",
                        _this.props.displayBlastLink &&
                            React.createElement("a", { href: blastUrl([accessionForBlast], rna) }, "Blast"))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier compatibility"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        psc.scale.labelA,
                        " / ",
                        psc.scale.detailA),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.scale.slidesWithUnit)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        psc.scale.labelB,
                        " / ",
                        psc.scale.detailB),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.scale.slidesWithUnit)),
                (admin && psc.probeSet instanceof RnaCishCatalogVariantRefProbeSet) &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Probe Size"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, psc.probeSet.variant.probeSetSize)),
                price && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(price.probeSetPriceCents))));
        };
        _this.rnaCishAmplifier = function (admin, amplifier, priceCents) {
            var _a, _b, _c, _d;
            return React.createElement(Grid, { className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "HCR\u2122 Pro RNA-ISH Amplifier"))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.hcrAmplifier.id)),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Hapten"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.hapten.name)),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Anti-Hapten #1"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten1.label)),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Tyramide Hapten"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.tyramideHapten.label)),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Anti-Hapten #2 AP"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_a = amplifier === null || amplifier === void 0 ? void 0 : amplifier.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.label)),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Anti-Hapten #2 HRP"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_b = amplifier === null || amplifier === void 0 ? void 0 : amplifier.antiHapten2Hrp) === null || _b === void 0 ? void 0 : _b.label)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Chromogen compatibility"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_c = amplifier === null || amplifier === void 0 ? void 0 : amplifier.antiHapten2Hrp) === null || _c === void 0 ? void 0 :
                        _c.chromogenCompatibility,
                        " & ", (_d = amplifier === null || amplifier === void 0 ? void 0 : amplifier.antiHapten2Ap) === null || _d === void 0 ? void 0 :
                        _d.chromogenCompatibility)),
                amplifier.amplifierScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ?
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            amplifier.amplifierScale.label,
                            " / ",
                            amplifier.amplifierScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.amplifierScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.amplifierScale.slidesWithUnit)),
                amplifier.antiHapten1Scale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        amplifier.antiHapten1Scale.label,
                        " / ",
                        amplifier.antiHapten1Scale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten1Scale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten1Scale.slidesWithUnit)),
                amplifier.tyramideHaptenScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        amplifier.tyramideHaptenScale.label,
                        " / ",
                        amplifier.tyramideHaptenScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.tyramideHaptenScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.tyramideHaptenScale.slidesWithUnit)),
                amplifier.antiHapten2ApScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        amplifier.antiHapten2ApScale.label,
                        " / ",
                        amplifier.antiHapten2ApScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten2ApScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten2ApScale.slidesWithUnit)),
                amplifier.antiHapten2HrpScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        amplifier.antiHapten2HrpScale.label,
                        " / ",
                        amplifier.antiHapten2HrpScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, amplifier.antiHapten2HrpScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.antiHapten2HrpScale.slidesWithUnit)),
                priceCents &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceCents))));
        };
        _this.rnaCishBuffers = function (admin, buffer, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "HCR\u2122 Pro RNA-ISH Buffers"))),
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Sample type"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.sampleType.label)),
                buffer.endogenousEnzymeScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        buffer.endogenousEnzymeScale.label,
                        " / ",
                        buffer.endogenousEnzymeScale.detail),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.endogenousEnzymeScale.slidesWithUnit)),
                buffer.preHybridizationScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        buffer.preHybridizationScale.label,
                        " / ",
                        buffer.preHybridizationScale.detail),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.preHybridizationScale.slidesWithUnit)),
                buffer.amplificationBufferScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        buffer.amplificationBufferScale.label,
                        " / ",
                        buffer.amplificationBufferScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buffer.amplificationBufferScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.amplificationBufferScale.slidesWithUnit)),
                buffer.blockingSolutionScale.slides > 0 && React.createElement(Grid.Row, null,
                    admin ? React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        buffer.blockingSolutionScale.label,
                        " / ",
                        buffer.blockingSolutionScale.detail) :
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, buffer.blockingSolutionScale.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.blockingSolutionScale.slidesWithUnit)),
                (buffer instanceof RnaCishLeicaBuffersComponent || buffer instanceof RnaCishOncoreProXBuffersComponent) && buffer.hrpQuencherScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                        buffer.hrpQuencherScale.label,
                        " / ",
                        buffer.hrpQuencherScale.detail),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.hrpQuencherScale.slidesWithUnit)),
                (buffer instanceof RnaCishLeicaBuffersComponent || buffer instanceof RnaCishOncoreProXBuffersComponent) && buffer.bluingAgentScale.slides > 0 &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            buffer.bluingAgentScale.label,
                            " / ",
                            buffer.bluingAgentScale.detail),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.bluingAgentScale.slidesWithUnit)),
                buffer instanceof RnaCishRocheBuffersComponent && buffer.antigenRetrievalScale.slides > 0 &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            buffer.antigenRetrievalScale.label,
                            " / ",
                            buffer.antigenRetrievalScale.detail),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.antigenRetrievalScale.slidesWithUnit)),
                buffer instanceof RnaCishRocheBuffersComponent && buffer.dewaxScale.slides > 0 &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            buffer.dewaxScale.label,
                            " / ",
                            buffer.dewaxScale.detail),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, buffer.dewaxScale.slidesWithUnit)),
                priceCents &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceCents))));
        };
        _this.rnaCishChromogenComponent = function (admin, chromogen, priceCents) {
            return React.createElement(Grid, { className: 'tight-rows' },
                admin && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Matisse\u00AE Chromogens"))),
                chromogen.chromogen && chromogen.chromogenScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, chromogen.chromogen.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.chromogenScale.slidesWithUnit)),
                chromogen.chromogenBuffer && chromogen.chromogenBufferScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, chromogen.chromogenBuffer.label),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.chromogenBufferScale.slidesWithUnit)),
                chromogen.hematoxylinScale.slides > 0 && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Hematoxylin"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, chromogen.hematoxylinScale.slidesWithUnit)),
                priceCents &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceCents))));
        };
        _this.rnaCishMiscComponent = function (miscComponent, price) {
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'chromogenic', size: 'small' }, "Other"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Item"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, miscComponent.description)),
                (miscComponent.scaleInSlides > 0 && miscComponent.scaleInMl.valueMl > 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        miscComponent.scaleInSlides,
                        " slides, ",
                        miscComponent.scaleInMl.valueWithUnit)),
                (miscComponent.scaleInSlides > 0 && miscComponent.scaleInMl.valueMl <= 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        miscComponent.scaleInSlides,
                        " slides")),
                (miscComponent.scaleInMl.valueMl > 0 && miscComponent.scaleInSlides <= 0) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, miscComponent.scaleInMl.valueWithUnit)),
                price &&
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(price.buffersPriceCents))));
        };
        _this.manualProAmpComponent = function (amplifier, sampleType, chromogen, priceCents) {
            var _a, _b, _c;
            return React.createElement(Grid, { className: 'tight-rows' },
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, null,
                        React.createElement(Header, { className: 'fluorescent', size: 'small' }, "HCR™ Pro Amplifier Kit"))),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Amplifier"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, amplifier.hcrAmplifier.id)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Enzyme"),
                    (((_a = amplifier.antiHapten2Ap) === null || _a === void 0 ? void 0 : _a.id) === "NONE" && ((_b = amplifier.antiHapten2Hrp) === null || _b === void 0 ? void 0 : _b.id) !== "NONE") &&
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, "HRP")),
                chromogen && (chromogen === null || chromogen === void 0 ? void 0 : chromogen.chromogen) && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Chromogen Kit"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, (_c = chromogen === null || chromogen === void 0 ? void 0 : chromogen.chromogen) === null || _c === void 0 ? void 0 : _c.label)),
                React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Scale"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, displayScaleLabelForCart(calculateNumOfTubesForAmp(amplifier.amplifierScale.pmolScale.valuePmol), calculateNumOfSlidesForAmp(amplifier.amplifierScale.pmolScale.valuePmol), "", sampleType))),
                priceCents !== undefined && React.createElement(Grid.Row, null,
                    React.createElement(Grid.Column, { width: KitDisplay.labelWidth }, "Price"),
                    React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                        "$",
                        formatMonetaryDecimal(priceCents))));
        };
        _this.optionallyPriceKit = function () {
            if (isKitDisplayProps1(_this.props)) {
                if (_this.props.pricedKit instanceof RnaFishPricedKit) {
                    return new OptionallyPriceRnaFishKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof Ihc2PricedKit) {
                    return new OptionallyPriceIhc2Kit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                else if (_this.props.pricedKit instanceof PricedBundleOfKits) {
                    return new OptionallyPriceBundleOfKits(_this.props.pricedKit.kit, _this.props.pricedKit.price);
                }
                return new OptionallyPriceRnaCishKit(_this.props.pricedKit.kit, _this.props.pricedKit.price);
            }
            else {
                if (_this.props.kit instanceof RnaFishKit) {
                    return new OptionallyPriceRnaFishKit(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof Ihc2Kit) {
                    return new OptionallyPriceIhc2Kit(_this.props.kit, undefined);
                }
                else if (_this.props.kit instanceof BundleOfKits) {
                    return new OptionallyPriceBundleOfKits(_this.props.kit, undefined);
                }
                return new OptionallyPriceRnaCishKit(_this.props.kit, undefined);
            }
        };
        _this.onCopyClick = function (rna) {
            var n = navigator;
            n.clipboard.writeText(rna)
                .then(function () {
                _this.setState({
                    copyButtonText: 'Copied!'
                });
                setTimeout(function () { return _this.setState({
                    copyButtonText: 'Copy'
                }); }, 2000);
            })
                .catch(function (e) {
                console.log("Could not copy: " + e);
            });
        };
        _this.state = {
            copyButtonText: 'Copy'
        };
        return _this;
    }
    KitDisplay.prototype.render = function () {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o, _p, _q, _r, _s, _t, _u, _v, _w, _x, _y, _z, _0;
        var priceKit = this.optionallyPriceKit();
        if (priceKit instanceof OptionallyPriceRnaFishKit) {
            var legacy = priceKit.kit.legacy;
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            React.createElement(Header, { className: 'fluorescent', size: 'small' }, "Sample type"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                priceKit.kit.probeSetComponent && this.probeSet(legacy, this.props.displayBlastLink, priceKit.kit.probeSetComponent, priceKit.kit.sampleType, (_a = priceKit.price) === null || _a === void 0 ? void 0 : _a.probeSetPriceCents),
                priceKit.kit.amplifierComponent && this.amplifier(legacy, priceKit.kit.amplifierComponent, priceKit.kit.sampleType, (_b = priceKit.price) === null || _b === void 0 ? void 0 : _b.amplifierPriceCents),
                priceKit.kit.buffersComponent && this.buffers(legacy, false, priceKit.kit.buffersComponent, (_c = priceKit.price) === null || _c === void 0 ? void 0 : _c.buffersPriceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Subtotal (USD)"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceKit.price.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceIhc2Kit) {
            var legacy = priceKit.kit.legacy;
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            React.createElement(Header, { className: 'fluorescent', size: 'small' }, "Sample type"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                priceKit.kit.probeComponent && this.ihc2Probe(priceKit.kit.probeComponent, priceKit.kit.sampleType, (_d = priceKit.price) === null || _d === void 0 ? void 0 : _d.probePriceCents),
                priceKit.kit.amplifierComponent && this.amplifier(legacy, priceKit.kit.amplifierComponent, priceKit.kit.sampleType, (_e = priceKit.price) === null || _e === void 0 ? void 0 : _e.amplifierPriceCents),
                priceKit.kit.buffersComponent && this.ihc2Buffers(legacy, priceKit.kit.buffersComponent, (_f = priceKit.price) === null || _f === void 0 ? void 0 : _f.buffersPriceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Subtotal (USD)"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal((_g = priceKit.price) === null || _g === void 0 ? void 0 : _g.subtotalCents)))));
        }
        else if (priceKit instanceof OptionallyPriceRnaCishKit) {
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, null,
                            React.createElement(Header, { className: 'chromogenic', size: 'medium' }, "HCR\u2122 Pro RNA-ISH")))),
                !this.props.admin &&
                    this.consumerRnaCishKit(priceKit.kit.protocolType, priceKit.kit.config, priceKit.kit.probeSetComponent, priceKit.kit.amplifierComponent, priceKit.kit.chromogenComponent, priceKit.kit.bufferComponent, priceKit.kit.miscComponent),
                this.props.admin && priceKit.kit.probeSetComponent && this.rnaCishProbeSet(this.props.admin, priceKit.kit.probeSetComponent, priceKit.price),
                this.props.admin && priceKit.kit.amplifierComponent && this.rnaCishAmplifier(this.props.admin, priceKit.kit.amplifierComponent, (_h = priceKit.price) === null || _h === void 0 ? void 0 : _h.amplifierPriceCents),
                this.props.admin && priceKit.kit.bufferComponent && this.rnaCishBuffers(this.props.admin, priceKit.kit.bufferComponent, (_j = priceKit.price) === null || _j === void 0 ? void 0 : _j.buffersPriceCents),
                this.props.admin && priceKit.kit.chromogenComponent && this.rnaCishChromogenComponent(this.props.admin, priceKit.kit.chromogenComponent, (_k = priceKit.price) === null || _k === void 0 ? void 0 : _k.chromogenPriceCents),
                this.props.admin && priceKit.kit.miscComponent && this.rnaCishMiscComponent(priceKit.kit.miscComponent, priceKit.price),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.kit.reasonForOther.length > 0 && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Reason For Other"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.reasonForOther)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Subtotal (USD)"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceKit.price.subtotalCents)))));
        }
        else {
            var probeSet = (_l = priceKit.kit.kits.find(function (k) { return k.channel === 1; })) === null || _l === void 0 ? void 0 : _l.probeSetComponents.find(function (p) {
                return p.index === 1 && p instanceof SimpleProbeSetComponent;
            });
            var probeSetPrice = (_o = (_m = priceKit.price) === null || _m === void 0 ? void 0 : _m.individualKitPrices.find(function (k) { return k.channel === 1; })) === null || _o === void 0 ? void 0 : _o.probeSetPrices.find(function (p) { return p.index === 1; });
            var amp = (_p = priceKit.kit.kits.find(function (k) { return k.channel === 1; })) === null || _p === void 0 ? void 0 : _p.amplifierComponents.find(function (a) {
                return a.index === 1 && a instanceof RnaCishAmplifierComponent;
            });
            var ampPrice = (_r = (_q = priceKit.price) === null || _q === void 0 ? void 0 : _q.individualKitPrices.find(function (k) { return k.channel === 1; })) === null || _r === void 0 ? void 0 : _r.amplifierPrices.find(function (a) { return a.index === 1; });
            var proBuffer = (_s = priceKit.kit.kits.find(function (k) { return k.channel === 1; })) === null || _s === void 0 ? void 0 : _s.buffersComponents.find(function (b) {
                return b.index === 2 && b instanceof RnaCishManualBuffersComponent;
            });
            var proBufferPrice = (_u = (_t = priceKit.price) === null || _t === void 0 ? void 0 : _t.individualKitPrices.find(function (k) { return k.channel === 1; })) === null || _u === void 0 ? void 0 : _u.buffersPrices.find(function (b) { return b.index === 2; });
            var chromogen = (_v = priceKit.kit.kits.find(function (k) { return k.channel === 1; })) === null || _v === void 0 ? void 0 : _v.chromogenComponents.find(function (c) {
                return c.index === 1;
            });
            var chromogenPrice = (_x = (_w = priceKit.price) === null || _w === void 0 ? void 0 : _w.individualKitPrices.find(function (k) { return k.channel === 1; })) === null || _x === void 0 ? void 0 : _x.chromogenPrices.find(function (c) { return c.index === 1; });
            var manualBuffer = (_y = priceKit.kit.kits.find(function (k) { return k.channel === 1; })) === null || _y === void 0 ? void 0 : _y.buffersComponents.find(function (b) {
                return b.index === 1 && b instanceof RnaFishBuffersComponent;
            });
            var manualBufferPrice = (_0 = (_z = priceKit.price) === null || _z === void 0 ? void 0 : _z.individualKitPrices.find(function (k) { return k.channel === 1; })) === null || _0 === void 0 ? void 0 : _0.buffersPrices.find(function (b) { return b.index === 1; });
            return React.createElement("div", { className: 'kit-display' },
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.labelWidth },
                            React.createElement(Header, { className: 'fluorescent', size: 'small' }, "Sample type"))),
                    React.createElement(Grid.Row, null,
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.sampleType.label))),
                probeSet && this.probeSet(false, this.props.displayBlastLink, probeSet, priceKit.kit.sampleType, probeSetPrice === null || probeSetPrice === void 0 ? void 0 : probeSetPrice.priceCents),
                !this.props.admin && amp && this.manualProAmpComponent(amp, priceKit.kit.sampleType, chromogen, addNullableValues(ampPrice === null || ampPrice === void 0 ? void 0 : ampPrice.priceCents, proBufferPrice === null || proBufferPrice === void 0 ? void 0 : proBufferPrice.priceCents, chromogenPrice === null || chromogenPrice === void 0 ? void 0 : chromogenPrice.priceCents)),
                this.props.admin && amp && this.rnaCishAmplifier(this.props.admin, amp, ampPrice === null || ampPrice === void 0 ? void 0 : ampPrice.priceCents),
                this.props.admin && proBuffer && this.rnaCishBuffers(this.props.admin, proBuffer, proBufferPrice === null || proBufferPrice === void 0 ? void 0 : proBufferPrice.priceCents),
                this.props.admin && chromogen && this.rnaCishChromogenComponent(this.props.admin, chromogen, chromogenPrice === null || chromogenPrice === void 0 ? void 0 : chromogenPrice.priceCents),
                manualBuffer && this.buffers(false, true, manualBuffer, manualBufferPrice === null || manualBufferPrice === void 0 ? void 0 : manualBufferPrice.priceCents),
                React.createElement(Divider, null),
                React.createElement(Grid, { className: 'tight-rows' },
                    React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Comment"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth }, priceKit.kit.comment)),
                    priceKit.price && React.createElement(Grid.Row, { width: KitDisplay.labelWidth },
                        React.createElement(Grid.Column, { className: 'assay-labels', width: KitDisplay.labelWidth }, "Subtotal (USD)"),
                        React.createElement(Grid.Column, { width: KitDisplay.valueWidth },
                            "$",
                            formatMonetaryDecimal(priceKit.price.subtotalCents)))));
        }
    };
    KitDisplay.labelWidth = 5;
    KitDisplay.valueWidth = 11;
    return KitDisplay;
}(React.PureComponent));
export default KitDisplay;
// tslint:disable-next-line:max-classes-per-file
var OptionallyPriceRnaFishKit = /** @class */ (function () {
    function OptionallyPriceRnaFishKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceRnaFishKit;
}());
// tslint:disable-next-line:max-classes-per-file
var OptionallyPriceIhc2Kit = /** @class */ (function () {
    function OptionallyPriceIhc2Kit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceIhc2Kit;
}());
var OptionallyPriceRnaCishKit = /** @class */ (function () {
    function OptionallyPriceRnaCishKit(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceRnaCishKit;
}());
var OptionallyPriceBundleOfKits = /** @class */ (function () {
    function OptionallyPriceBundleOfKits(kit, price) {
        this.kit = kit;
        this.price = price;
    }
    return OptionallyPriceBundleOfKits;
}());
var isKitDisplayProps1 = function (b) {
    return b.pricedKit !== undefined;
};
export var abbreviateRnaWithModal = function (rnaSeq, includeCopyButton) {
    if (rnaSeq.length <= 40) {
        return React.createElement("span", null,
            rnaSeq,
            " ");
    }
    else {
        return React.createElement(React.Fragment, null,
            React.createElement("span", null, rnaSeq.substr(0, 20) + '…' + rnaSeq.substr(rnaSeq.length - 20, 20)),
            " ",
            includeCopyButton && copyButton(rnaSeq));
    }
};
var copyButton = function (rnaSeq) {
    var handler = function () {
        // navigator.clipboard isn't exposed in TS yet
        var n = navigator;
        n.clipboard.writeText(rnaSeq)
            .catch(function (e) {
            console.log("Could not copy: " + e);
        });
    };
    return React.createElement(Button, { icon: 'copy', size: 'mini', onClick: handler });
};
// export const compactAccessionsListWithPopup = (accessions: string[]) => {
//     if (accessions.length === 0) {
//         return noAccessionsMsg;
//     } else if (accessions.length === 1) {
//         // don't bother truncating here, we have more real estate
//         return accessionSearchLink(accessions[0]);
//     } else {
//         return <React.Fragment>{accessions[0]}, … {accessionsPopup(accessions)}</React.Fragment>
//     }
// };
export var rnaModal = function (rnaSeq, label) {
    return React.createElement(Modal, { trigger: React.createElement(Button, { label: label, icon: 'search plus', size: 'mini' }), closeIcon: true },
        React.createElement(Modal.Header, null,
            "RNA target sequence (",
            rnaSeq.length,
            " nt)"),
        React.createElement(Modal.Content, null,
            React.createElement("span", { style: { 'overflowWrap': 'break-word', 'fontFamily': 'monospace' } }, rnaSeq)));
};
export var accessionSearchLink = function (accession) {
    return React.createElement("a", { href: "https://www.ncbi.nlm.nih.gov/nuccore/?term=" + encodeURIComponent(accession), target: '_blank' }, accession);
};
// export const compactAccessionsListWithPopup = (accessions: string[]) => {
//     if (accessions.length === 0) {
//         return noAccessionsMsg;
//     } else if (accessions.length === 1) {
//         // don't bother truncating here, we have more real estate
//         return accessionSearchLink(accessions[0]);
//     } else {
//         return <React.Fragment>{accessions[0]}, … {accessionsPopup(accessions)}</React.Fragment>
//     }
// };
export var compactRnaCishAccessionsListWithPopup = function (accessions) {
    if (accessions.length === 0) {
        return noAccessionsMsg;
    }
    else if (accessions.length === 1) {
        // don't bother truncating here, we have more real estate
        return accessionSearchLink(accessions[0].transcriptAccession);
    }
    else {
        return React.createElement(React.Fragment, null,
            accessions[0].transcriptAccession,
            ", \u2026 ",
            rnaCishAccessionsPopup(accessions));
    }
};
var blastUrl = function (accessions, rna) {
    return "https://blast.ncbi.nlm.nih.gov/Blast.cgi?PAGE_TYPE=BlastSearch&USER_FORMAT_DEFAULTS=on&SET_SAVED_SEARCH=true&PAGE=Nucleotides&PROGRAM=blastn&QUERY=" + encodeURIComponent(accessions.join("\n")) + "&SUBJECTS=" + encodeURIComponent(rna) + "&JOB_TITLE=" + encodeURIComponent(accessions.join(", ")) + "&GAPCOSTS=5%202&MATCH_SCORES=2,-3&BLAST_SPEC=blast2seq&DATABASE=&BLAST_PROGRAMS=blastn&MAX_NUM_SEQ=100&SHORT_QUERY_ADJUST=on&EXPECT=10&WORD_SIZE=11&REPEATS=repeat_9606&TEMPLATE_TYPE=0&TEMPLATE_LENGTH=18&FILTER=L&FILTER=m&PROG_DEFAULTS=on&SHOW_OVERVIEW=on&SHOW_LINKOUT=on&ALIGNMENT_VIEW=Pairwise&MASK_CHAR=2&MASK_COLOR=1&GET_SEQUENCE=on&NUM_OVERVIEW=100&DESCRIPTIONS=100&ALIGNMENTS=100&FORMAT_OBJECT=Alignment&FORMAT_TYPE=HTML";
};
export var numOfBindingSitesDisplay = function (pss) {
    if (pss === 1) {
        return "Special (1)";
    }
    else if (pss > 1 && pss <= 20) {
        return "Standard (Up to 20)";
    }
    else {
        return "Boosted (Up to 40)";
    }
};
export var numOfBindingSites = function (pss) {
    if (pss === 1) {
        return 1;
    }
    else if (pss > 1 && pss <= 20) {
        return 20;
    }
    else {
        return 40;
    }
};
export var addNullableValues = function () {
    var values = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        values[_i] = arguments[_i];
    }
    // Check if all values are undefined
    if (values.every(function (v) { return v === undefined; }))
        return undefined;
    // Otherwise, sum them, treating undefined as 0
    return values.reduce(function (sum, v) { return sum + (v !== null && v !== void 0 ? v : 0); }, 0);
};
//# sourceMappingURL=KitDisplay.js.map


//////////////////
// WEBPACK FOOTER
// ../common/build/dist/kit/rna-fish/KitDisplay.js
// module id = 35
// module chunks = 0